module.exports = __webpack_public_path__ + "static/img/icon_class_watch.11c12b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_class_watch.png
// module id = RMNm
// module chunks = 1